let React              = require("react");
let Thumbnail          = require("./Thumbnail.jsx");  
let Utility            = require("../../util/Utilities.js");
let ApplicationContext = require("../../config/ApplicationContext.js");

class ThumbnailPlaceholder extends React.Component {

	render(){

		const { objUrl, resource, layout, isTrash, Action } = this.props;

		return <React.Fragment>
                { layout == "list" &&
                    <div className={`card__icon ${isTrash? "switch": ""}`}>
                        <Action 
                            objUrl={objUrl}
                            Content={()=>
                                <Thumbnail
                                    src={`${ApplicationContext.assetUrlPrefix}/assets/icons/icon-file.svg`} 
                                    alt={`${resource.name}\n${resource.summary}`} 
                                />}
                        />
                    </div> }

                { layout == "grid" &&
                    <React.Fragment>
                        <div className="card__name nameNoImage">
                            <p className="card__name__title">{resource.name}</p>
                        </div>
                        <div className="card__description descNoImage">
                            {Utility.formatDescription(resource.summary, "grid")}
                        </div>
                        <div className="card__image noCursor"/>
                    </React.Fragment> }
                </React.Fragment>
	}
}

module.exports = ThumbnailPlaceholder;